import React, {useContext} from "react"
import {TextField, Box, Button} from "@mui/material"
import Grid from '@mui/material/Grid';
import makeStyles from "@material-ui/core/styles/makeStyles";
import OutlinedInput from '@mui/material/OutlinedInput';
import {NumberFormatCustom} from "../../services/validation";
import Switch from '@mui/material/Switch';
import {updateCategoryStatus} from "../../api/category";
import {LoadingContext} from "../../hoc/loading";
import {MessageContext} from "../../hoc/messageNotification";
import InputAdornment from '@mui/material/InputAdornment';
import {SUPER_ADMIN} from "../../constants";
import {RoleContext} from "../../hoc/role";
import {useConfirm} from "material-ui-confirm";

const useStyles = makeStyles({
    input: {
        margin: '0px',
    },
    main: {
        margin: 0,
        padding: 0
    },
    title: {
        fontSize: '24px',
        fontWeight: 'bold',
    },
    label: {
        fontSize: '16px',
        fontWeight: 'bold',
    },
});

export const Item = ({category, onChangeData,  ind, removeCategory, subCategory=false, edit}) => {
    const classes = useStyles();
    const {setLoading} = useContext(LoadingContext);
    const {setErrorMessage} = useContext(MessageContext);
    const {role} = useContext(RoleContext);
    const confirm = useConfirm();

    const updateCategory = async (category) => {
        try {
            setLoading(true);
            setErrorMessage(null);
            const {id, active} = category
            await confirm({
                title: '',
                description: 'Deactivated category is not playing!'})
            await updateCategoryStatus(id, active)
        } catch (e) {
            category['active'] = !category['active']
            setErrorMessage(e);
        }
        setLoading(false);
    }

    const onChange = async (event, category) => {
        event.stopPropagation()
        event.preventDefault()
        try{
            const name = event.target.name
            const value = event.target.checked

            category[name] = value

            await updateCategory(category)
        }catch (e) {
            setErrorMessage(e);
        }
    }

    return (
        <Grid className={classes.main} key={ind} container spacing={1}>
                {subCategory ? <Grid item xs={0} md={1}></Grid> : ''}
                <Grid item xs={12} md={subCategory ? 5 : 6}>
                    <Box sx={{m: 0}} variant="outlined">
                        <OutlinedInput
                            fullWidth
                            disabled={subCategory || category.active ? true : false}
                            id="outlined-adornment-weight"
                            value={category.name}
                            endAdornment={
                                !subCategory ? <InputAdornment position="end">
                                    <Button onClick={() => edit(category.id)} variant="text">Edit</Button>
                                    {role === SUPER_ADMIN && <Button color="error" onClick={() => removeCategory(category.id)} variant="text">Remove</Button>}
                                </InputAdornment> : ''

                            }
                        />
                    </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Grid container spacing={1}>
                        <Grid item xs={6} md={5}>
                            <TextField
                                InputProps={{
                                    inputComponent: NumberFormatCustom,
                                }}
                                max={100}
                                disabled
                                className={classes.input}
                                value={category.free}
                                name='free'
                                label="Free"
                                variant="outlined"/>
                        </Grid>
                        <Grid item xs={6} md={5}>
                            <TextField className={classes.input}
                                       value={category.purchased}
                                       disabled
                                       name='purchased'
                                       InputProps={{
                                           inputComponent: NumberFormatCustom,
                                       }}
                                       max={100}
                                       label="Purchased" variant="outlined"/>
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <Box sx={{'textAlign': 'center'}}>
                                <Switch className={classes.input}
                                        checked={category.active} name='active'
                                        onClick={(e) => e.stopPropagation()}
                                        onChange={(e) => onChange(e, category)}/>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
    )
}